export default __webpack_public_path__ + "static/rsz_zeton_b-6326b2f7327894124fbca3183e9e18c4.png";